import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";

interface IProps extends BoxProps { }

export const GradientDivider: React.FC<IProps> = (props) => (
	<Box bgGradient="linear(to-r, secondary.500, primary.500)" h={3} {...props} />
);
